import React from "react";
import PropTypes from "prop-types";

const HtmlView = ({ content }) => {
    return (
        <div dangerouslySetInnerHTML={{ __html: content }} />
    );
};
const BannerMessage = ({ banner, notification_count, onClickClose }) => {

    return (
        <div id="notification-bar" className={`container-fluid shadow py-2 bg-${banner?.banner_type}`}>
            <div className="d-flex justify-content-around align-items-center">
                <span className="fa-stack" data-count={notification_count}>
                    <i className="fa fa-circle fa-stack-2x" style={{color: 'rgb(105, 97, 97)'}}></i>
                    <i className="fa fa-bell fa-stack-1x fa-inverse"></i>
                </span>
                <span className="text-center text-light mx-3 w-100">
                    <HtmlView content={banner?.message || ""} />
                </span>
                <button type="submit" title="close" className="btn-close btn-close-white me-2 m-auto" onClick={(e) => {
                    e.preventDefault();
                    onClickClose(banner);
                }}></button>
            </div>
        </div>)
}

BannerMessage.propTypes = {
    banner: PropTypes.any,
    notification_count: PropTypes.any,
    onClickClose: PropTypes.func,
}

export default BannerMessage